import { render, staticRenderFns } from "./mediaItem.vue?vue&type=template&id=08ff9a08&scoped=true&"
import script from "./mediaItem.vue?vue&type=script&lang=js&"
export * from "./mediaItem.vue?vue&type=script&lang=js&"
import style0 from "./mediaItem.vue?vue&type=style&index=0&id=08ff9a08&prod&scoped=true&lang=css&"
import style1 from "./mediaItem.vue?vue&type=style&index=1&id=08ff9a08&prod&scoped=true&lang=scss&"
import style2 from "./mediaItem.vue?vue&type=style&index=2&id=08ff9a08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff9a08",
  null
  
)

export default component.exports